/**
 * author: Roger That <frederick@rogerthat.be>
 * date: 08/02/2022
 **/
require("./bootstrap");

import selectize, { count } from "selectize.js";
import $ from "jquery";
import ajaxForm from "jquery-form";
import iFrameResizer from "iframe-resizer/js/iframeResizer.contentWindow";
import { indexOf, words } from "lodash";

$(() => {
    // job app rt functionality
    jobAppForm.init();
    jobAppFilter.init();

    window.addEventListener("load", () => {
        parent.postMessage({ location: window.location.href }, "*");
    });

    window.iFrameResizer = {
        targetOrigin: "*",
        heightCalculationMethod: "lowestElement",
        onReady: function () {
            console.log("iFrameResizer ready");
        },
    };

    function inIframe() {
        try {
            return window.self !== window.top;
        } catch (e) {
            return true;
        }
    }

    // redirect to jobsite if not in iframe
    if (
        window.location.href === "https://jobs.sintferdinand.be/vacatures" &&
        !inIframe()
    ) {
        window.location.href = "https://sintferdinand.be/jobsite/jobs/";
    }

    // redirect to jobsite, to a detail hash if not in iframe
    if (
        typeof isDetail !== "undefined" &&
        isDetail === true &&
        !inIframe() &&
        isProduction
    ) {
        // add class to body
        const hash = "#" + vacancyId + "/" + vacancySlug;
        window.location.href = "https://sintferdinand.be/jobsite/jobs/" + hash;
    }
});

// selectize & ajax upload
const jobAppForm = {
    init() {
        // declare properties
        this.activeFormId = "";
        this.vacanciesSelectInstance = null;

        // cache dom elements
        this.cacheElements();

        // define selectize actions & events
        this.actionSelectize();

        // start form upload actions
        this.actionFormUpload();

        // specify action
        this.actionSpecify();
    },
    cacheElements() {
        // select & radio elements for job selection
        this.$selectVacancies = $("#vacanciesSelect");
        this.$selectVacanciesOptions = $(`#vacanciesSelect option`);
        this.$radioApplicationType = $('input[name="application_type"]');

        // specify origin select & input
        this.$selectOrigin = $("#candidateOrigin");
        this.$inputSpecifyOrigin = $("#specifyOrigin");

        // four individual upload forms
        this.$formUpload = $(".form_upload");
        this.$inputFile = $('input[type="file"]');
    },
    actionSelectize() {
        this.vacanciesSelectInstance = this.$selectVacancies.selectize();
        this.$radioApplicationType.on("change", (e) => {
            if (this.vacanciesSelectInstance[0]) {
                this.vacanciesSelectInstance[0].selectize.destroy();
            }
            const type = e.target.value;
            const options = this.$selectVacanciesOptions;

            options.each((index, option) => {
                const optType = option.dataset.type;
                option.disabled = !(type == optType);
                option.selected = false;
            });
            this.vacanciesSelectInstance = this.$selectVacancies.selectize();
        });

        if (this.$selectVacancies.val()) {
            showOptionalRequiredLabels(
                document.querySelector("#vacanciesSelect")
            );
        }

        this.$selectVacancies.on("change", (e) => {
            showOptionalRequiredLabels(e.target);
        });

        function showOptionalRequiredLabels(vacancies) {
            const options = vacancies.options;
            const requiredFields = [];
            $(options).each((ind, ele) => {
                const vacancyId = ele.value;
                const requiredVacancyFields =
                    requiredFilesPerVacancy[vacancyId];
                for (const field of requiredVacancyFields) {
                    if (indexOf(requiredFields, field) <= 0) {
                        requiredFields.push(field);
                    }
                }
            });

            $(".a-badge").hide();
            $(".a-badge.--optional").show();
            requiredFields.forEach((field) => {
                $(`#${field}-required`).show();
                $(`#${field}-optional`).hide();
            });
        }
    },
    actionFormUpload() {
        this.$inputFile.on("change", (e) => {
            const formQuery = `#${e.target.dataset.form}`;
            $(formQuery).trigger("submit");
        });

        this.$formUpload.ajaxForm({
            beforeSubmit: function (formData, jqForm) {
                jobAppForm.activeFormId = jqForm[0].id;
                const targetData = $(
                    `#${jobAppForm.activeFormId} input[type="file"]`
                ).data();
                $(`#${targetData.progress}`).css("width", "0%").html("0%");
                $(`#${targetData.error}`).text("");
            },
            beforeSend: function () {
                var percentage = "0";
            },
            uploadProgress: function (event, position, total, percentComplete) {
                var percentage = percentComplete;
                var targetData = $(
                    `#${jobAppForm.activeFormId} input[type="file"]`
                ).data();

                $(`#${targetData.progress}`)
                    .removeClass("bg-red-500")
                    .removeClass("bg-green-500")
                    .addClass("bg-blue-500")
                    .css("width", percentage + "%")
                    .html(percentage + "%");

                if (percentage == 100) {
                    $(`#${targetData.progress}`)
                        .css("width", "99%")
                        .html("99%"); // only done when it's done
                }
            },
            error: function (err) {
                var targetData = $(
                    `#${jobAppForm.activeFormId} input[type="file"]`
                ).data();
                const errorMessages = err.responseJSON.errors;
                if (errorMessages.length <= 0) {
                    alert("Er ging iets mis");
                    return false;
                }
                const errorMessage = errorMessages.file[0];
                $(`#${targetData.error}`).text(errorMessage);
                $(`#${targetData.progress}`)
                    .css("width", "0%")
                    .removeClass("bg-blue-500")
                    .addClass("bg-red-500")
                    .html("0%");
            },
            complete: function (xhr) {
                // something went wrong
                if (xhr.status != 200) return false;

                // get filename or return false
                const fileName = xhr.responseJSON.fileName;
                if (!fileName) return false;

                // get related fields
                var targetData = $(
                    `#${jobAppForm.activeFormId} input[type="file"]`
                ).data();

                // change to 100
                $(`#${targetData.progress}`)
                    .css("width", "100%")
                    .html("100%")
                    .removeClass("bg-red-500")
                    .removeClass("bg-blue-500")
                    .addClass("bg-green-500");

                // fill in targetdata hidden field
                $(`#${targetData.hidden}`).val(fileName);

                $(`#${targetData.preview}`)
                    .attr("href", `/storage/${fileName}`)
                    .css("display", "inline-flex");
            },
        });
    },
    actionSpecify() {
        this.$selectOrigin.on("change", (e) => {
            const dataset = this.$selectOrigin.find(":selected").data();
            if (!dataset.specify) {
                this.$inputSpecifyOrigin.addClass("hidden");
                this.$inputSpecifyOrigin
                    .find("input")
                    .val("")
                    .prop("required", false);
            } else {
                this.$inputSpecifyOrigin.removeClass("hidden");
                this.$inputSpecifyOrigin
                    .find("input")
                    .attr("placeholder", dataset.specify)
                    .prop("required", true);
            }
        });
    },
};

// filter logic with url updates
const jobAppFilter = {
    init() {
        // only execute this if there are multiple vacancies on the webpage & filters
        if (typeof filters == "undefined") return false;
        this.filters = filters;
        this.filterKeys = filterKeys;
        this.url = window.location.href;

        this.cacheElements();
        this.eventListeners();

        this.initUrlFilter();
    },
    cacheElements() {
        this.$allVacancies = $(".m-vacancy");
        this.$checkboxFilter = $("input.chb_filter");
    },
    eventListeners() {
        this.$checkboxFilter.on("click", (e) => {
            // set parameters
            const isChecked = e.target.checked;
            const key = e.target.dataset.key;
            const value = e.target.value;

            this.filters[key] = this.addOrRemove(
                this.filters[key],
                value,
                isChecked
            );
            this.actionFilter();
            this.updateUrlFilter();
        });
    },
    actionFilter() {
        // init show all vacancies on filter change
        this.$allVacancies.hide();

        this.$allVacancies.each((index, element) => {
            let showVacancy = true;
            const vacancyFilters = element.dataset;
            filterKeys.forEach((key) => {
                const cFilter = vacancyFilters[key];
                if (
                    showVacancy &&
                    (this.filters[key].includes(cFilter) ||
                        typeof cFilter === "undefined")
                ) {
                    // console.log(element.dataset);
                } else {
                    showVacancy = false;
                }
            });
            if (showVacancy) {
                element.style.display = "block";
            }
        });
    },
    addOrRemove(array, item, add) {
        const exists = array.includes(item);

        if (exists && !add) {
            return array.filter((c) => {
                return c !== item;
            });
        } else if (add && !exists) {
            const result = array;
            result.push(item);
            return result;
        }
    },
    initUrlFilter() {
        // let url = this.url;
        // // remove # from url
        // if (url.includes("#")) {
        //     url = url.split("#")[0] + url.split("#")[1];
        // }
        // this.url = url;
        const pageUrl = new URL(this.url);
        const filterParams = pageUrl.searchParams;

        this.filterKeys.forEach((key) => {
            const filterValues = filterParams.get(key);
            if (!filterValues) return false;

            const filterValuesArray = filterValues.split(",");
            // console.log(key);

            const checkBoxFilters = document.querySelectorAll(
                `input[data-key="${key}"]`
            );
            checkBoxFilters.forEach((element) => {
                const val = element.value;

                if (indexOf(filterValuesArray, val) < 0) {
                    element.checked = false;
                    this.filters[key] = this.addOrRemove(
                        this.filters[key],
                        val,
                        0
                    );
                }
            });
        });

        this.actionFilter();
    },
    updateUrlFilter() {
        // return;
        let urlString = "?";
        // console.log(this.filters);
        this.filterKeys.forEach((key) => {
            const countActiveFilters = this.filters[key].length;
            const countCheckboxFilters = document.querySelectorAll(
                `input[data-key="${key}"]`
            ).length;
            // console.log(countActiveFilters, countCheckboxFilters);
            if (countActiveFilters != countCheckboxFilters) {
                const filterString = this.filters[key].join(",");
                urlString += `${key}=${filterString}&`;
            }
        });

        const filteredUrl = urlString.slice(0, -1);
        var newRelativePathQuery = window.location.pathname + filteredUrl;
        history.replaceState(null, "", newRelativePathQuery);
    },
};
